import { on, fire } from "delegated-events";
import ajax from "@common/ajax";
import { trackGoogleAnalytics } from "@common/util";
import "@styles/components/subscribe-form.css";

const showFormMessages = (holder, message, success, autoHide) => {
  holder.style.display = "block";
  holder.innerHTML = message;

  if (success) {
    holder.classList.remove("form-message-error");
  } else {
    holder.classList.add("form-message-error");
  }

  if (autoHide) {
    setTimeout(() => {
      holder.style.display = "none";
    }, 5000);
  }
};

const toggleSubmit = (submitButton) => {
  submitButton.disabled = !submitButton.disabled;
  submitButton.classList.toggle("btn-loading");
};

export default {
  init: () => {
    on("submit", ".subscribe-form", (e) => {
      e.preventDefault();

      const form = e.target;
      const email = e.target.querySelector('[type="email"]');
      const formMessages = form.querySelector(".form-messages");
      const submitButton = form.querySelector("[type=submit]");

      toggleSubmit(submitButton);

      if (email.validity.valueMissing || email.validity.typeMismatch) {
        showFormMessages(formMessages, "Please enter a valid email", false, true);

        submitButton.disabled = false;

        return;
      }

      const formData = new FormData(form);

      ajax
        .url(form.action)
        .body(formData)
        .post()
        .json((res) => {
          if (res.success) {
            if (res.ga) {
              res.ga.forEach((event) => trackGoogleAnalytics(event));
            }

            form.reset();

            // Allow other scripts to hook into this submit
            fire(document.documentElement, "ajaxform:submit", {
              form: form,
              type: "post",
              url: new URL(form.action),
              queryParameters: new URLSearchParams(formData).toString(),
            });
          }

          if (res.message) {
            showFormMessages(formMessages, res.message, res.success, false);
          }
        })
        .catch((e) => {
          console.log(e);
          showFormMessages(formMessages, "Sorry, there was a problem with your submission", false, true);
        })
        .finally(() => {
          toggleSubmit(submitButton);
        });
    });
  },
};
